import { queryIsLoading, queryNotLoading } from './global-actions';
import axios from 'axios';
import Swal from 'sweetalert2';

const apiUrl = process.env.REACT_APP_API_URL;

export function getReport( cbFunction, token ) {
    return (dispatch) => {
        dispatch(queryIsLoading());
        axios.get(`${apiUrl}/legal-case/generate-report`, {
            headers: {
                token
            },
            params: {
                skip: 0,
                limit: 0
            }
        }).then(result => {
            if (result.status === 200) {
                dispatch(queryNotLoading());
                cbFunction(result.data)
            }
        }).catch(error => {
            if (error.response) {
                if (error.response.status === 400) {
                    Swal.fire({
                        title:"¡Error!",
                        confirmButtonColor:"#76b4ff",
                        text: error.response.data.message
                    });
                } else {
                    Swal.fire({
                        title:"¡Error!",
                        confirmButtonColor:"#76b4ff",
                        text: "Hubo un error, vuelve a intentarlo, Si el error persiste contacte al administrador."
                    });
                }
            } else if (error.request) {
                console.log(error.request);
                Swal.fire({
                    title:"¡Error!",
                    confirmButtonColor:"#76b4ff",
                    text: "Hubo un error, vuelve a intentarlo, Si el error persiste contacte al administrador."
                });
            } else {
                console.log('Error', error.message);
                Swal.fire({
                    title:"¡Error!",
                    confirmButtonColor:"#76b4ff",
                    text: "Hubo un error, vuelve a intentarlo, Si el error persiste contacte al administrador."
                });
            }
            dispatch(queryNotLoading());
        })
    }
}